import { render, staticRenderFns } from "./prepositioner-som-styr-ackusativ-eller-dativ.vue?vue&type=template&id=3d9c485d&scoped=true"
import script from "./prepositioner-som-styr-ackusativ-eller-dativ.vue?vue&type=script&lang=js"
export * from "./prepositioner-som-styr-ackusativ-eller-dativ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9c485d",
  null
  
)

export default component.exports